export default __webpack_public_path__ + "static/media/search.15050b71.png";